export enum PdfType {
    DEFAULT = 'default',
    CLIENT_LIST = 'clientList',
    FORECAST_END_RESULT_LIST = 'forecastEndResultList',
}
